import z from "zod";
import EncodedCheckoutState from "../../../model/misc/EncodedCheckoutState";

export const relocationRequestUrlParam = new EncodedCheckoutState(
  z.object({
    article: z.enum([
      "cms-hosting",
      "cms-hosting-express",
      "onlineshop",
      "onlineshop-express",
    ]),
  }),
);
